export class AjaxClick {
    constructor() {
        e5.on({
            type: "click",
            selector: "[data-e5buildcall]",
            listener: (e) => {
                var url = e.target.getAttribute("data-e5buildcall");
                var r = new XMLHttpRequest();
                r.open('GET', url);
                r.send();
            }
        });
    }
}